import dayjs from 'dayjs'
import { BarConfig, ColumnConfig, LineConfig } from '@ant-design/plots'

export const BloodGlucose: ColumnConfig = {
  data: [],
  color: '#38C172',
  xField: 'recordDate',
  yField: 'value',
  meta: {
    recordDate: {
      alias: 'Record Date',
      formatter: (value) => dayjs(value, 'YYYY-MM-DD').format('M/DD'),
    },
  },
}

export const MobilityChairRisesChart: ColumnConfig = {
  data: [],
  isGroup: true,
  seriesField: 'type',
  xField: 'recordDate',
  yField: 'value',
  yAxis: {
    max: 20,
    tickInterval: 1,
  },
  meta: {
    recordDate: {
      alias: 'Record Date',
      formatter: (value) => dayjs(value, 'YYYY-MM-DD').format('M/DD'),
    },
    type: {
      formatter: (value) => (value === 'within12s' ? 'Within 12 secs' : 'Within 30 secs'),
    },
  },
  color: (datum): string => {
    if (datum.type === 'within12s') return '#7966FF'
    return '#38C172'
  },
}

export const BloodPressure: ColumnConfig = {
  ...BloodGlucose,
  isGroup: true,
  seriesField: 'type',
  yField: 'value',
  yAxis: {
    max: 200,
    tickInterval: 50,
  },
  legend: false,
  meta: {
    ...BloodGlucose.meta,
    value: {
      alias: 'mmHg',
      formatter: (value: number) => `${value}`,
    },
    type: {
      formatter: (value) => (value === 'diastolic' ? 'Dia (mmHg)' : (value === 'systolic' ? 'Sys (mmHg)' : 'HR (bpm)')),
    },
  },
  color: (datum): string => {
    if (datum.type === 'diastolic') return '#7966FF'
    else if (datum.type === 'heartRate') return 'red'
    return '#38C172'
  },
}

export const NutritionDistribution: BarConfig = {
  data: [],
  xField: 'value',
  yField: 'key',
  seriesField: 'key',
  legend: false,
  barWidthRatio: 0.5,
  color: (datum): string => {
    if (datum.key === 'carbsPercent') return '#9EB7FF'
    if (datum.key === 'proteinPercent') return '#FF9CB4'
    return '#FFCC00'
  },
  meta: {
    value: {
      formatter: (value: number) => `${value.toFixed(1)} %`,
    },
    key: {
      formatter: (value: string) => {
        const name = value.replace(/Percent/g, '')
        return name[0].toUpperCase() + name.slice(1)
      },
    },
  },
}
